import { useMutation, UseMutationResult } from '@tanstack/react-query';

const STRAPI_BASE_URL = import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337/api';

export function useStrapiPost<TInput, TResponse = unknown>(
  endpoint: string,
): UseMutationResult<TResponse, Error, TInput> {
  return useMutation<TResponse, Error, TInput>({
    mutationFn: async (input: TInput) => {
      const res = await fetch(`${STRAPI_BASE_URL}/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: input }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData?.error?.message || 'Failed to post data');
      }

      return res.json() as Promise<TResponse>;
    },
    mutationKey: ['strapi', endpoint, 'post'],
  });
}
